module.exports = __webpack_public_path__ + "img/ca.4d433fc3.svg";